import { defineLazyComponent } from "../defineLazyComponent";

/**
 * Async-loaded wrapper around MapGeolocation.vue, which pulls in maplibre-gl.
 * Always import this instead of MapGeolocation.vue directly, so the map
 * library stays in its own chunk and isn't included in the main bundle.
 *
 * No fallbacks: the component is renderless and lives inside the map, where
 * `.reset-children` strips the styling off anything we put there. A missing
 * geolocation button is a tolerable degradation.
 */
export const MapGeolocationAsync = defineLazyComponent(
  () => import("./MapGeolocation.vue"),
  { loadingComponent: null, errorComponent: null },
);
